<svelte:options />

<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions, a11y_mouse_events_have_key_events -->
<div bind:this={thisToken} id="{token.ID}-T" data-help="map" data-char={token.ID}
     class="button token" class:currentChar={token.ID === view.perspective}
     class:greyed={game.inEncounter && (!token.isVisible || typeof visible === 'number')}
     class:visible={visible}
     draggable={user.isMaster}
     transition:fade
     onclick={handle_onclick}
     ondragstart={pickup_token}
     onmouseleave={hide_impact}
     onmouseover={show_impact}
     style:--col={token.position.col} style:--row={token.position.row}
     style:--size={token.size}
     style:--success={activity?.success ?? 0}
     style:--visrange={token.visibility} style:opacity={(1 - hide) * visible}
     title="{activitySymbol.title}: {token.rolled}&#10;&#13;kontrolliert: {token.controlleds?.join(', ')}">


	<div class="affiliation affil-{token.affil} rank{token.rank}">
		<div bind:this={damage} class="damage"></div>
		<img bind:this={imgElem} class="portrait" src={token.tokenURL} alt={token.ID} draggable={user.isMaster} />
		<div class="name-background-clip">
			<div class="name-background affil-{token.affil} rank{token.rank}">
				<div class="name-label name-label-{token.affil} rank{token.rank}">
					<p class="name-text">{token.ID}</p>
				</div>
			</div>
		</div>
	</div>
	<div bind:this={damSymbol} class="damSymbol">
		<div class="dam injurs">
			{#if injurSymbol}
				<img class="injur {injurSymbol}" src="/static/images/{injurSymbol}.svg">
			{/if}
			<!--
			TODO: check if injur was already treated
				<img class="injur injur-xl" src="/static/images/injur-xl${ token.treated ? "-treated" : ""}.svg">
			-->
		</div>
		<div class="dam wounds">
			{#each damages['W'] as wound,i}
				<svg class:lower={i===1} xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18">
				  <path class="wound" class:treated="{wound.healed}"
				        d="M 6.1105123,3.8500977e-8 C 5.8882936,0.35494214 3.1579612,4.1572633 1.9041569,6.8369333 0.65035803,9.5166593 0.08805303,11.043488 0.08805303,11.043488 c -0.24391,1.531847 -0.2914103,5.270186 4.20443327,5.964129 4.495842,0.693998 5.520883,-3.07836 5.491475,-4.219126 C 9.7231913,10.433738 9.3933403,10.116926 8.0669343,7.8782893 6.3392533,4.9622393 6.1105123,3.8500979e-8 6.1105123,3.8500977e-8 Z"/>
				</svg>
			{/each}
		</div>
	</div>
	<div class=orientation style:--orientation={(activitySymbol.state) ? null : orientation} >
		<img src="/static/images/{activitySymbol.symbol}.png" alt=""
			 class=activity class:state={activitySymbol.state}
			 style="filter: {activitySymbol.filter}; rotate: {activitySymbol.rotate}rad" />
	</div>
	{#if incoming}
        <div class="effectPopup" transition:blur={{duration: 400}}>
            <img class="effectImage" src="/static/images/{incoming.kind}.png" alt="effects">
            <span class="effectText">{incoming.text}</span>
        </div>
	{/if}
</div>


<script>
  import { user, game, view } from "../client.svelte.js";
	import {Location, impactHue, protoActions, are_comrades} from "../core.js";
  import {blur, fade} from "svelte/transition";
	import {show_strikes} from "./Encounter.svelte";

  let { token } = $props();
	// uses:    ID, TYPE, name, affil, rank,
  //          position, size, visibility, controlled, tokenURL, activity, orienation,
  //          operative, isStunned, isDisabled, hide, health, damanges, condition,
	// $inspect(`TOKEN - token ${token.ID}`, token)

  let thisToken, imgElem, damage, damSymbol       // reference to this elements
  let activity = $derived(game.activities.get(token.activity) ?? null)
  let actInflicts
	let orientation = $derived((token.orientation !== null) ? Math.round(token.orientation * 100) / 100 : null)	// show orientation of token (in which direction is the fighter looking) by small triangle
  let activitySymbol = $derived.by(() => {
		if (token.isStunned) return {symbol: "Stunned", state: true, title: "Benommen", filter: null}
		if (token.activity) {
			const activity = game.activities.get(token.activity) ?? {}
			const actImpact = protoActions[activity.action]?.kind
			return {
				symbol: (activity.ZUB === 'Performance' || ["Wechsel", "Bogen und Schwert"].includes(activity.action)) ? activity.action : activity.ZUB,
				state: (activity.ZUB === 'Performance' || ["Wechsel", "Bogen und Schwert"].includes(activity.action)),
				title: (activity.rolled && user.isMaster) ? `${activity.descript}: ${activity.rolled}` : `${activity.descript}`,
				filter: (actImpact in impactHue) ? `hue-rotate(${impactHue[actImpact]}deg) brightness(${(actImpact === 'harm') ? 300 : 100}%) drop-shadow(0 0 2px black)` : null,
				rotate: (activity.ZUB === 'Attack' || activity.ZUB === 'Shoot') ? 0 : -orientation,
			}
		}
		return {symbol: "waiting", state: true, title: "Wartet", filter: null}
	})

	const combinedKind = {'nerf,hurt': 'harm', 'hurt,nerf': 'harm', 'nerf,harm': 'harm', 'harm,nerf': 'harm'}

	let incoming = $derived.by(() => {
		if (!token)  return null
		const inflicts = game.infos.values()
			.filter(infl => infl.ZUB === 'Inflict' && infl.target === token.ID && infl.time === game.time && !('MUTED' in infl.flags))
			.toArray()
		if (inflicts.length === 0)
			return null
		else {
			let kind = ""
			let text = ""
			for (let inflict of inflicts) {
				if (inflict.force > 0) {
					for (let effect of inflict.effects.map(effID => game.effects.get(effID)).filter(eff => eff)) {
						kind = (!kind || kind === effect.kind) ? effect.kind : 'harm'
						text += effect.effect
					}
				}
			}
			return {kind: kind, text: text}
		}
		// .toSorted((imp1,imp2) => imp1.potency)
	})
  //ToDo: show strikes when holding (mouseover subject)
  //  if (!view.hold) setInterval(() => incoming = null, duration)
  // $inspect("TOKEN - incoming", incoming)

  const duration = 2000	// time the inflict is shown in [ms]

  let hide = $derived(1.5 / (1 + Math.exp(-token.hide.total / 10)) - 0.75)     // apply logistic function to hide
  let damages = $derived(
	  Object.groupBy(
		  Object.values(token.affects)
			  .map(effID => game.effects.get(effID))
			  .filter(eff => eff && (eff.severity === 'W' || eff.severity === 'V'))
		  , ({severity}) => severity ) )
  let injurSymbol = $derived({1: 'injur-s', 2: 'injur-m', 3: 'injur-l', 4: 'injur-xl'}[damages['V']?.length])


		/*** subcribe to changes of selected characters (role) ***/
    $effect(() => {
        // show movement path if character is moving
        if (view.persona === token.ID && view.persona.activity) {
            show_activity()
			try {
				actInflicts = activity.implics.map(inflID => game.infos.get(inflID))
						.filter(incid => incid.ZUB === 'Inflict' || incid.ZUB === 'Increase')
			} catch {
				actInflicts = []
			}
        }
		})

		$effect(() => {
			if (!game.mode)  return
			// update health gauge (blacked affiliation ring), hide disabled fighters
			// ring around token fills black if damages
			// we use 2 segments a 120° (the third segment is not used because it would be hidden behind the name label)
			// 2 x 120 = 240 -> 240 = 100% of life energy
			const healthRatio = token.life / token.vital;
			const damageRatio = Math.round((1 - healthRatio) * 100);
			const damageAngle = Math.round(240 / 100 * damageRatio);
			if(damage !== null) {
				const gradient = damageAngle < 120 ?
				`
					transparent				0deg							240deg,
					black					240deg							${(240 + damageAngle)}deg,
					transparent				${(240 + damageAngle + 1)}deg	360deg
				`:
				`
					black					0deg 							${(damageAngle - 120)}deg,
					transparent				${(damageAngle - 120 + 1)}deg	240deg,
					black					240deg							360deg
				`;

				damage.style.background = `conic-gradient(${gradient})`;
			}

		})

		/** check if token is visible **/
		function check_visibility(viewer, superimposed, thisMapID, time, playables) {}

		/** check if token is visible **/
		let visible = $derived.by(() => {
			if (!game.inEncounter)		// not in encounter means that map is in deployment mode
				return (token.condition === 'Invisible') ? 0.4 : (token.condition === 'Hidden') ? 0.7 : 1.0
			// console.log(`TOKEN - check visibility of ${entity.ID} for ${view.perspective}`, $state.snapshot(entity))
			/** react to changed viewer after DOM has been created **/
			const viewer = game.personas.get(view.perspective) ?? null
			if (viewer && !viewer.detecteds)
				return (view.map.ID === token.position.map && (user.isMaster || are_comrades(view.persona, token.ID)))
			if (viewer && viewer.ID === token.ID)
				return true
			else if (user.isMaster) {
				if (!view.superimposed && token.position.map !== view.map.ID)
						return false
				else if (viewer)
						return (viewer.detecteds.includes(token.ID)) ? true : 1.0
				else
						return (token.position.map === view.map.ID) ? true : (view.superimposed) ? 0.5 : false
			} else if (viewer) {
				console.assert(viewer, `MAP: Viewpoint ${viewer} is not possible for player ${user.name}`)
				const vis = viewer.detecteds.includes(token.ID) || game.playables.includes(token.name) //  || client.avails.includes(entity.character)
				if (!vis && token.ID in viewer.lastseens)
					return 1 - (game.time - viewer.lastseens[token.ID]) / 10
				//ToDo: use position in viewer.lastseen for this entity
				return vis
			}
		})


    function show_activity() {
        /** visualisze activity of this fighter on map **/
        const activity = game.activities.get(token.activity)
        const fighter = (token.TYPE === 'Character') ? token : null
        const movement = (fighter && activity && ['Movement', 'Charge'].includes(activity.ZUB)) ? activity : null
        view.path = movement
		}

		function calc_seen_success(nowTime) {
				if (!activity) return 0
				const alpha = Math.round((user.isMaster) ? 100 : 100 - Math.min(activity.time - nowTime, 10) * 10)
				return activity.success * alpha / 100
		}

    function show_impact() {
        if (user.isMaster || token.ID === view.persona?.ID) {
            show_strikes(actInflicts)
            show_activity()
        }
		}

    function hide_impact() {
        show_strikes(null)
        if (user.isMaster)  view.path = null
		}


    export function move(newPos, movement) {
        // console.log(`TOKEN: Move entity ${entity.ID} to new position ${newPos} with movement: `, movement)
        if (!(newPos instanceof Location)) newPos = new Location(newPos)
        const covered = (movement?.dur) ? movement.length / movement.dur : movement?.length ?? 0
        const movetime = (movement?.speed) ? Math.round(covered * 500 / movement.speed) : 0  // 500ms for 1 field at speed 1F/s
        // console.assert((movetime === 1), `!!! Movetime for ${entity.ID} is ${movetime}`)
        if (token.ID === view.persona && newPos.map && newPos.map !== view.map.ID && user.isMaster)
            view.switch_map(newPos.map)
        if (view.persona === token.ID)
            show_activity(movement)
		}

	    function pickup_token(e) {
        view.dragParams = {typ: 'move', ID: token.ID, level: token.level, rank: token.rank, condition: token.condition}
				console.log(`TOKEN - pickup appear`, token)
        e.dataTransfer.setData('char/ID', token.ID)
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setDragImage(imgElem, 25, 25) // (e.target.firstElementChild, 10, 10)
		}


    function handle_onclick(e) {
				e.stopPropagation()
				// console.log(`TOKEN - click on token `, $state.snapshot(token))
				if (view.layout.page === 'deploy')
						view.show_dialog('appearance', {deploy: token})
				else
						view.select_persona(token.ID)
    }
</script>


<style lang="sass">
	.token
		position: absolute
		left: calc((var(--col) - var(--size) / 2) * 78px)
		top:  calc((var(--row) - var(--size) / 2) * 78px)
		width:  calc(var(--size) * 74px)
		height: calc(var(--size) * 74px)
		border-radius: 50%
		box-shadow: 10px 10px 5px rgb(0 0 0 / 0.6)
		visibility: hidden
		transition: all var(--timestep) linear

	.token.selected
		box-shadow: 0 0 30px 10px white
		border-radius: 50%

	.token.move
		transition: all 1s linear

	.token.visible
		visibility: visible

	.token.greyed
		filter: brightness(0.7) saturate(0%)


	.token > *
		pointer-events: none

	.token .portrait
		position: absolute
		top: 5px
		left: 5px
		width:  calc(var(--size) * 74px - 10px)
		height: calc(var(--size) * 74px - 10px)
		clip-path: circle(50% at 50% 50%)

	.token .affiliation
		width: calc(var(--size) * 74px)
		height: calc(var(--size) * 74px)
		border-radius: 50%
		display: flex
		flex-flow: column-reverse nowrap
		background: linear-gradient(330deg, var(--secondary-color), var(--primary-color), var(--primary-color), white)

	.token .damage
		width: calc(var(--size) * 74px)
		height: calc(var(--size) * 74px)
		border-radius: 50%
		position: absolute

	.token .name-background-clip
		width: 100%
		height: 18px
		overflow: hidden
		position: relative
		background: transparent

	.token .name-background
		width: calc(var(--size) * 74px - 2px)
		height: calc(var(--size) * 74px - 2px)
		border-radius: 50%
		position: absolute
		bottom: 0
		left: 0.5px
		background: linear-gradient(330deg, var(--secondary-color), var(--primary-color), var(--primary-color), white)

	.token .name-label
		display: inline-block
		padding-top: calc(14px + 74px * (var(--size) - 1))
		width: calc(var(--size) * 74px - 2px)
		height: calc(var(--size) * 74px / 2)
		border-radius: 0 0 calc(var(--size) * 74px * 4) calc(var(--size) * 74px * 4)
		margin-top: 36px
		background: linear-gradient(90deg, transparent 10%, var(--secondary-color), transparent 90%)
		/* background: grey */

	.token .name-text
		font-size: 14px
		text-align: center
		/* text-shadow: 1px 1px 3px white, 1px 1px 3px white color: black */

	.affil-fellow
		--primary-color:	#0000ff
		--secondary-color:	#000080

	.affil-friend
		--primary-color:	#1f991f
		--secondary-color:	#136613

	.affil-neutral
		--primary-color:	#999999
		--secondary-color:	#666666

	.affil-neutral.rank1
		--primary-color:	#999
		--secondary-color:	#660

	.affil-neutral.rank2
		--primary-color:	#777
		--secondary-color:	#421

	.affil-neutral.rank3
		--primary-color:	#555
		--secondary-color:	#211

	.affil-enemy.rank1
		--primary-color:	#e6e60b
		--secondary-color:	#686800

	.affil-enemy.rank2
		--primary-color:	#e6780b
		--secondary-color:	#663b0f

	.affil-enemy.rank3
		--primary-color: 	#cc1414
		--secondary-color:	#660a0a

	.affil-enemy.rank
		--primary-color:	#7e17e6
		--secondary-color:	#460d80


	.token .damSymbol
		position: absolute
		left: -15px
		top: 30px
		width: 40px
		height: 56px
		display: flex
		flex-flow: column nowrap
		align-items: center
		justify-content: center

	.token .damSymbol img
		filter: drop-shadow(0 0 2px black)
		color: red


	.token .damSymbol .wounds,
	.token .damSymbol .injurs
		display: flex
		justify-content: center
		width: 100%
		height: auto

	.token .damSymbol .wounds
		margin-top: 3px
		margin-left: 10px

	.token .damSymbol .wound.lower
		transform: translateY(10px)

	.wound
		fill: red

	.wound.treated
		fill: lightgray
		stroke: red
		stroke-width: 2px

	.token .damSymbol .injur-s
		width: calc(59px / 4)
		height: calc(56px / 4)

	.token .damSymbol .injur-m
		width: calc(95px / 4)
		height: calc(61px / 4)

	.token .damSymbol .injur-l
		width: calc(124px / 4)
		height: calc(70px / 4)

	.token .damSymbol .injur-xl
		width: calc(158px / 4)
		height: calc(80px / 4)

	.token .damSymbol .dam
		display: flex
		flex-flow: row nowrap
		align-items: flex-start

	.orientation
		position: absolute
		width:  calc(var(--size) * 74px)
		height: calc(var(--size) * 74px)
		rotate: calc(var(--orientation) * 1rad)
		left: 0
		top: 0

	.activity
		position: absolute
		width:   calc(max(var(--success), 1) * 34px)
		height:  calc(max(var(--success), 1) * 34px)
		translate: calc(var(--size) * 20px + 8px) calc(var(--success) * -8px - 16px)
		filter: drop-shadow(0 0 2px black)

	.activity.state
		right: -4px
		bottom: -2px
		width: 24px
		height: 24px
		translate: none

	.token .orientationImg
		position: relative
		width:  calc(var(--size) * 74px)
		height: calc(var(--size) * 74px)
		/*transform: rotate(calc(var(--orientation) * 1rad))*/


	.currentChar
		--visrange: 100	/* no restriction */

	.currentChar:after
		content: ''
		position: absolute
		left: calc(-1 * var(--visrange) * 74px + 30px)
		top:  calc(-1 * var(--visrange) * 74px + 30px)
		width: calc(2 * var(--visrange) * 74px)
		height: calc(2 * var(--visrange) * 74px)
		border-radius: 100%
		box-shadow: 0 0 0 8000px rgb(0 0 0 / 50%)
		pointer-events: none



	/**** effects ****/

	.effectPopup
		position: absolute
		left: 0
		top: 0
		z-index: 1
		opacity: 70%
		visibility: unset
		text-align: center

	.showEffect
		animation-duration: 1s
		animation-name: popup
		animation-fill-mode: forwards

	@keyframes popup
		from
			visibility: hidden
		50%
			visibility: visible
		to
			visibility: hidden

	.effectImage
		position: relative
		left: -16px
		top:  - 8px
		width: 100px

	.effectText
		position: absolute
		top: 10px
		left: 0
		width: 80px
		font-size: large
		font-weight: bold

	.areaEffect
		position: absolute
		border-radius: 50%
		opacity: 70%


</style>
